import axios from './interceptor';

const QRY_URL = `${process.env.REACT_APP_BASE_URL}/queries`;

export async function createQueries(payload) {
    const ADDUSER_URL = `${QRY_URL}/create-queries`;
    const result = await axios.post(ADDUSER_URL, payload);
    return result.data;
};

export async function getAllQueries(page, size, filters = {}) {
    try {
        const GETUSER_URL = `${QRY_URL}/get-all-queries`;
        const result = await axios.get(GETUSER_URL, {
            params: { page, size, ...filters }
        });
        return result.data;
    } catch (error) {
        console.error('Error fetching queries:', error);
        throw error;
    }
}

export async function getGroupedQueries(filters = {}) {
    try {
        const GET_GROUPED_URL = `${QRY_URL}/get-grouped-queries`;
        const result = await axios.get(GET_GROUPED_URL, { params: filters });
        return result.data;
    } catch (error) {
        console.error('Error fetching grouped queries:', error);
        throw error;
    }
}

export async function confirmTrip(id) {
    const CONFIRM_URL = `${QRY_URL}/confirm-trip/${id}`;
    const result = await axios.put(CONFIRM_URL);
    return result.data;
}

export async function getSalesMetrics() {
    try {
        const GET_METRICS_URL = `${QRY_URL}/sales-metrics`;
        const result = await axios.get(GET_METRICS_URL);
        return result.data;
    } catch (error) {
        console.error('Error fetching sales metrics:', error);
        throw error;
    }
}

export async function updateQueries(id, value) {
    const UPDATEUSER_URL = `${QRY_URL}/update-single-field/${id}`;
    const result = await axios.patch(UPDATEUSER_URL, value);
    return result.data;
}

export async function fetchOperationByQueries(id) {
    const GETUSER_URL = `${QRY_URL}/fetch-operation/${id}`;
    const result = await axios.get(GETUSER_URL);
    return result.data;
}

export async function assignUsersToQueries(payload) {
    const UPDATEUSER_URL = `${QRY_URL}/assign-users`;
    const result = await axios.patch(UPDATEUSER_URL, payload);
    return result.data;
}
export async function removeUsersFromQueries(payload) {
    const UPDATEUSER_URL = `${QRY_URL}/remove-users`;
    const result = await axios.patch(UPDATEUSER_URL, payload);
    return result.data;
}

export async function deleteQueries(id) {
    const DELETEUSER_URL = `${QRY_URL}/delete-queries/${id}`;
    const result = await axios.delete(DELETEUSER_URL);
    return result.data;
}

export async function addQueryRemark(id, payload) {
    const ADD_REMARK_URL = `${QRY_URL}/add-remark/${id}`;
    const result = await axios.post(ADD_REMARK_URL, payload);
    return result.data;
}

export async function updateQueryRemark(queryId, remarkId, payload) {
    const UPDATE_REMARK_URL = `${QRY_URL}/update-remark/${queryId}/${remarkId}`;
    const result = await axios.put(UPDATE_REMARK_URL, payload);
    return result.data;
}

export async function deleteQueryRemark(queryId, remarkId) {
    const DELETE_REMARK_URL = `${QRY_URL}/delete-remark/${queryId}/${remarkId}`;
    const result = await axios.delete(DELETE_REMARK_URL);
    return result.data;
}

export async function getSingleQuery(id) {
    const SINGLE_URL = `${QRY_URL}/get-single-queries/${id}`;
    const result = await axios.get(SINGLE_URL);
    return result.data;
};
